import { A4uEdit as IconComponent } from '@adobe/react-spectrum-workflow/dist/Edit.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function Edit(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}